module.exports = __webpack_public_path__ + "img/li.71e792cf.svg";